'use strict';

import React from 'react';
import { AnimatedSwitch, spring } from 'react-router-transition';

function mapStyles(styles) {
  return {
    opacity: styles.opacity,
    transform: styles.offset > 25 ? `translateX(${ styles.offset }px)` : `none`,
  };
}

function glide(val) {
  return spring(val, {
    stiffness: 174,
    damping: 19,
  });
}

const pageTransitions = {
  atEnter: {
    offset: 200,
    opacity: 0,
  },
  atLeave: {
    offset: glide(-100),
    opacity: glide(0),
  },
  atActive: {
    offset: glide(0),
    opacity: glide(1),
  },
};


const ModifiedAnimatedSwitch = ({ children }) => (
  <AnimatedSwitch
    { ...pageTransitions }
    mapStyles={ mapStyles }
    className={ `switch` }>
    { children }
  </AnimatedSwitch>
);

export default ModifiedAnimatedSwitch;



// WEBPACK FOOTER //
// ./src/components/utilities/AnimatedSwitch.jsx